import Vue from 'vue';

const Bus = new Vue()

if (window && !window.VueBus) {
  window.VueBus = Bus
}

export default Bus
